var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('file-view',{attrs:{"editable":false,"show-file":true,"accept":".pdf, image/*","attachId":_vm.attachId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }